import { Ledgerentries  } from "../../../master/ledger/shared/ledgerentries.model";

export class Voucher {
    Id:Number ;
    VoucherNumber :String ;
    VoucherTypeId :Number ;
    VoucherDate: Date;
    VoucherAmount: Number;
    VoucherTotalDebit:Number;
    VoucherTotalCredit:Number;
    Narration: string;
    ApprovalStatusId:Number;
    ReceiptTypeId:Number;
    EmployeeId :Number ;
    EmployeeBranchId :Number ;  // uncommented on 3-06-2023
    CompanyId :Number ;
    BranchId :Number ;
    SaasId : Number ;
    CreatedDate: Date;
    ModifiedDate: Date;
    IsActive  :Number;
    Flag : Number;

    FromDate :Date;
    ToDate: Date;
    // ToDate : String;
    // FromDate: String;
    ReportName: String;

    Ledgerentries : Ledgerentries;
    LedgerentriesList : Ledgerentries[];

    ListByApprovalStatus: Number;  // for choosing SP only
    // ReceiptTypeName:string;
    TransactionId : Number;
    CentreId : Number;
}

